import { defineRouting } from "next-intl/routing";
import { DEFAULT_LOCALE, LOCALE_PREFIX, LOCALES } from "@/configs";

export const routing = defineRouting({
  locales: LOCALES,
  defaultLocale: DEFAULT_LOCALE,
  localePrefix: LOCALE_PREFIX,
});
